import { Card, Grid, Typography } from "@mui/material";
import React from "react";

const ReportCard = ({ title, value, footer, multiValue = false, longValue = false }) => {
  return (
    <Card
      sx={{
        minHeight: 130,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "3px 10px 0 10px",
      }}
    >
      <Typography
        sx={{
          fontSize: 15,
          textAlign: "center",
        }}
      >
        {title}
      </Typography>
      {multiValue ? (
        <Grid container>
          {value.map((item, idx) => (
            <Grid item key={idx} xl={6} lg={6} sm={6} xs={6}>
              <Typography
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 35,
                }}
              >
                {item}
              </Typography>
              {footer && footer[idx] ? (
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: 15,
                  }}
                >
                  {footer[idx]}
                </Typography>
              ) : null}
            </Grid>
          ))}
        </Grid>
      ) : (
        <>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: longValue ? 18 : 35,
            }}
          >
            {value}
          </Typography>
          <Typography>{footer}</Typography>
        </>
      )}
    </Card>
  );
};

export default ReportCard;
